import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import ConfirmDialog from '@/shared/ConfirmDialog'
import EditRegisteredUserCard from './EditRegisteredUserCard'

const mapStateToProps = ({ loading }) => ({ isLoading: loading['user/editUser'] })
const EditRegisteredUserDialog = ({ dispatch, isLoading, onClose, onComplete, data, ...props }) => {
  const cardRef = useRef()
  const { t } = useTranslation()

  const handleClose = () => {
    onClose?.()
  }

  const handleSubmit = () => {
    const { userGroup, ...putData } = cardRef.current.getValues()

    dispatch({
      type: 'user/editUser',
      payload: { ...putData, userId: data.userId },
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.user_updated'), severity: 'success' },
        })

        onComplete?.()
        handleClose?.()
      },
      errorCallback: message => {
        cardRef.current.setError('email', { type: 'custom', message })
      },
    })
  }

  return (
    <ConfirmDialog
      {...props}
      open={!!data}
      title={t('general.edit_registered_user')}
      loading={isLoading}
      onClose={handleClose}
      onSubmit={async () => {
        handleSubmit()
      }}
    >
      <EditRegisteredUserCard ref={cardRef} dispatch={dispatch} data={data} loading={isLoading} />
    </ConfirmDialog>
    // <Dialog {...props} open={!!data} maxWidth={'md'}>
    //   <DialogTitle>{t('general.edit_registered_user')}</DialogTitle>
    //   <DialogContent>
    //     <EditRegisteredUserCard ref={cardRef} dispatch={dispatch} data={data} loading={isLoading} />
    //   </DialogContent>
    //   <DialogActions>
    //     <Button color={'white'} loading={isLoading} disabled={isLoading} onClick={handleClose}>
    //       {t('general.cancel')}
    //     </Button>
    //     <Button
    //       color={'btn_positive'}
    //       loading={isLoading}
    //       disabled={isLoading}
    //       onClick={async () => {
    //         handleSubmit()
    //       }}
    //     >
    //       {t('general.complete')}
    //     </Button>
    //   </DialogActions>
    // </Dialog>
  )
}

export default connect(mapStateToProps)(EditRegisteredUserDialog)
